import { data } from './data/movies';

export default {
  get({ values }) {
    return [200, data.data.find((item) => item.id === values.id)];
  }
};
